import React from 'react';
import { useConfig } from '../context/ConfigContext';

/**
 * DemoBanner - Shows a read-only banner for demo tenant
 * Only displays when subdomain is "demo"
 */
function DemoBanner() {
  const { isDemoMode } = useConfig();

  if (!isDemoMode()) {
    return null;
  }

  return (
    <div className="demo-banner">
      <span className="demo-banner-text">
        <span className="demo-banner-icon">🔒</span>
        This is a read-only demo. Sign up for a free trial to test all features.
      </span>
      <a
        href="https://deedstack.com/signup"
        className="demo-banner-cta"
        target="_blank"
        rel="noopener noreferrer"
      >
        Start Free Trial
      </a>
    </div>
  );
}

export default DemoBanner;
